import { useMemo } from "react";
import { useGetJobQuery, useGetJobsQuery } from "./jobEndpoints";
import { Job } from "../../entities/job";

export function useJob(jobID: number | undefined) {
  const jobQuery = useGetJobQuery(jobID ?? 0, {
    skip: (jobID ?? 0) <= 0,
  });
  const jobEntity = jobQuery.data;

  return useMemo(() => {
    const ret: typeof jobQuery & { job?: Job | undefined } = {
      ...jobQuery,
    };
    if (jobEntity) ret.job = new Job(jobEntity);
    return ret;
  }, [jobEntity]);
}

export function useJobs(params?: any, options?: any) {
  const jobQuery = useGetJobsQuery(params, options);
  const jobEntitiesMap = jobQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof jobQuery & {
      jobs?: Job[];
      jobsMap?: { [id: number]: Job };
    } = {
      ...jobQuery,
      jobs: [],
      jobsMap: {},
    };
    if (jobEntitiesMap) {
      const jobs: Job[] = [];
      const jobsMap: { [id: number]: Job } = {};

      for (const key in jobEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(jobEntitiesMap, key)) {
          const c = jobEntitiesMap[key];
          const job = new Job(c);
          jobs.push(job);
          jobsMap[job.id] = job;
        }
      }
      ret.jobs = jobs;
      ret.jobsMap = jobsMap;
    }

    return ret;
  }, [jobEntitiesMap]);
}
